/** Action key that carries Axios external calls info interpreted by this Redux Middleware. */
export const AXIOS_REQUEST = 'AXIOS_REQUEST';
